import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { Contract } from "appworks/utils/contracts/contract";

/** @deprecated Move to class function */
export function HomeCommand(homeURL: string, onSessionClose: Function) {
    return new Contract<boolean>((resolve) => {

        const prompt = new PromptContentSubcomponent(["yes_no"], Infinity, Layers.get("Alerts"));

        prompt.setText("body", Services.get(TranslationsService).get("gen.cex"));

        prompt.addButton("continue", () => {
            prompt.hide().then(() => {
                if (onSessionClose) {
                    onSessionClose();
                }

                if (homeURL === "close") {
                    window.close();
                } else {
                    window.open(homeURL, "_self");
                }

                resolve(true);
            });
        });
        
        prompt.addButton("no", () => {
            prompt.hide().execute();
            resolve(false);
        });

        Components.get(PromptComponent).showPrompt(prompt).then(() => {
            if (onSessionClose) {
                onSessionClose();
            }

            if (homeURL === "close") {
                window.close();
            } else {
                window.open(homeURL, "_self");
            }

            resolve(true);
        });
    });

}
